import { createContext } from 'react';

export const ContextFavorites = createContext();
